/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-23 20:37:45
 * @LastEditTime: 2019-07-24 14:41:11
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  我的收藏接口
const getConllectionUrl = '/website/personal/conllection/find'

/* 收藏接口 */
const conllectionUrl = `/website/personal/conllection/save`

/* 预约看仓 */
const appointmentUrl = `/website/storage/appointment`

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 预约看仓 */
export function appointment(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + appointmentUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'appointmentSave'
      }, param))
    }
  })
}

// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}

// 分页查询我的收藏
export function findCollection(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getConllectionUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findCollection'
      }, param))
    }
  })
}

/* 收藏货源 */
export function conllection(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + conllectionUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'saveCollection'
      }, param))
    }
  })
}
